import Vue from 'vue';
import { Backend } from '@/_axios';

// import mutations from './mutations'
// import actions from './actions'
// import moment from 'moment';

export const LOAD_PLANNED_VACATIONS = 'LOAD_PLANNED_VACATIONS';
export const SET_PLANNED_VACATIONS = 'SET_PLANNED_VACATIONS';

export const CREATE_PLANNED_VACATION = 'CREATE_PLANNED_VACATION';
export const SET_PLANNED_VACATION = 'SET_PLANNED_VACATION';

export const DELETE_PLANNED_VACATION = 'DELETE_PLANNED_VACATION';
export const REMOVE_PLANNED_VACATION = 'REMOVE_PLANNED_VACATION';

export const RECALCULATE_PERIOD = 'RECALCULATE_PERIOD';

const state = {
  plannedVacactions: {}
};

const getters = {
  plannedVacations: (state) => {
    return state.plannedVacactions;
  }
};

const actions = {
  [LOAD_PLANNED_VACATIONS]: function ({ commit }) {
    Backend.get('/api/planned-vacations').then((response) => {
      const plannedVacactions = {};
      response.data.forEach((plannedVacation) => {
        plannedVacactions[plannedVacation.id] = plannedVacation;
      });
      commit('SET_PLANNED_VACATIONS', { plannedVacactions: plannedVacactions });
    });
  },
  [CREATE_PLANNED_VACATION]: function ({ commit }, data) {
    return Backend.post('/api/planned-vacation', data).then((response) => {
      commit('SET_PLANNED_VACATION', { plannedVacaction: response.data });
    });
  },
  [DELETE_PLANNED_VACATION]: function ({ commit }, id) {
    return Backend.delete('/api/planned-vacation', { params: { id: id } }).then((response) => {
      commit('REMOVE_PLANNED_VACATION', id);
    });
  },
  [RECALCULATE_PERIOD]: function ({ commit }, data) {
    return Backend.patch('/api/planned-vacations', data);
  }
};

const mutations = {
  [SET_PLANNED_VACATIONS]: function (state, { plannedVacactions }) {
    state.plannedVacactions = plannedVacactions;
  },
  [SET_PLANNED_VACATION]: function (state, { plannedVacaction }) {
    Vue.set(state.plannedVacactions, plannedVacaction.id, plannedVacaction);
  },
  [REMOVE_PLANNED_VACATION]: function (state, id) {
    Vue.delete(state.plannedVacactions, id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
